import languageLoader from "@/js/language-loader";
export default {
	lang: languageLoader(),
	phoneNumber: '+52 998 300 5906'
};
